import { render, staticRenderFns } from "./carte.vue?vue&type=template&id=2f477ce2&"
import script from "./carte.vue?vue&type=script&lang=js&"
export * from "./carte.vue?vue&type=script&lang=js&"
import style0 from "./carte.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports